// src/pages/Login.js — 로그인 (끝나면 원래 가려던 화면으로)
import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { userLogin } from '../api/dietApi';
import { useToast } from '../components/ui/Toast';
import './Auth.css';

export default function Login() {
  const navigate = useNavigate();
  const location = useLocation();
  const toast = useToast();
  const [userId, setUserId] = useState(location.state?.userId || '');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const from = location.state?.from || '/';

  const submit = async (e) => {
    e.preventDefault();
    if (loading) return;
    if (!userId || !password) { setError('아이디와 비밀번호를 입력해 주세요.'); return; }
    setLoading(true); setError('');
    try {
      const res = await userLogin(userId, password);
      const { token, userId: id } = res.data || {};
      if (!token) throw new Error('no token');
      localStorage.setItem('token', token);
      if (id) localStorage.setItem('userId', String(id));
      window.dispatchEvent(new Event('storage'));
      toast('로그인했습니다.', { type: 'success' });
      navigate(from, { replace: true });
    } catch (err) {
      const msg = err?.response?.data?.message || (typeof err?.response?.data === 'string' ? err.response.data : '');
      setError(msg || '아이디 또는 비밀번호를 확인해 주세요.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth">
      <form className="auth-card" onSubmit={submit}>
        <h2>로그인</h2>
        {location.state?.required && <p className="auth-note">로그인이 필요한 화면이에요.</p>}
        {location.state?.signedUp && <p className="auth-note ok">가입이 끝났어요. 로그인해 주세요.</p>}
        <label className="auth-field">
          <span>아이디</span>
          <input className="input" value={userId} autoComplete="username" onChange={(e) => setUserId(e.target.value)} autoFocus />
        </label>
        <label className="auth-field">
          <span>비밀번호</span>
          <input className="input" type="password" value={password} autoComplete="current-password" onChange={(e) => setPassword(e.target.value)} />
        </label>
        {error && <p className="auth-error">{error}</p>}
        <button className="btn primary auth-submit" type="submit" disabled={loading}>{loading ? '로그인 중…' : '로그인'}</button>
        <p className="auth-alt">계정이 없으신가요? <Link to="/signup">회원가입</Link></p>
      </form>
    </div>
  );
}
